import * as React from "react";

function FunnelIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.244 1.554A41.277 41.277 0 0110 1c2.3 0 4.558.19 6.756.554A1.49 1.49 0 0118 3.027V4.63a2.25 2.25 0 01-.659 1.59l-4.121 4.122a.75.75 0 00-.22.53v2.779a3 3 0 01-1.158 2.368L8.21 18.842A.75.75 0 017 18.25v-7.379a.75.75 0 00-.22-.53L2.66 6.22A2.25 2.25 0 012 4.629V3.027a1.49 1.49 0 011.244-1.473z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = React.forwardRef(FunnelIcon);
export default ForwardRef;